export const LOADING_STATUES = {"LOADING": "LOADING", "SUCCESS":"SUCCESS" }
export const ALERT_TYPES = {"OK": "OK", "WARNING": "WARNING", "INFO": "INFO" }